



import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getList: '/org/paginated',
    getById: '/org/id',
    create: '/org/save',
    update: '/org/update',
    delete: '/org/delete',
    
}

const useOrgRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getOrgList = async (payload) => {
      
        return await executeApi(REPO_URL.getList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getOrgById = async (payload) => {
        return await executeApi(REPO_URL.getById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const createOrg = async (payload) => {
        return await executeApi(REPO_URL.create, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const updateOrg = async (payload) => {
        return await executeApi(REPO_URL.update, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const deleteOrg = async (payload) => {
        return await executeApi(REPO_URL.delete, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    return {
        isLoading,
        data,
        error,
        getOrgList,
        getOrgById,
        createOrg,
        updateOrg,
        deleteOrg
    }
}

export default useOrgRepo
